var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 126,
    viewBox: "0 0 113 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.646785 53.8028C0.646785 53.7392 0.710331 53.6757 0.710331 53.6121C0.710331 53.5486 0.773878 53.5486 0.773878 53.4851C0.773878 53.4215 0.837424 53.4215 0.837424 53.358C1.47289 51.8328 2.48963 50.5619 3.69701 49.8629L4.01474 49.6723L46.4002 25.2069L88.7856 0.74156L89.1033 0.550921C90.3107 -0.148089 91.5816 -0.148089 92.5984 0.360282C92.5984 0.360282 92.6619 0.360282 92.6619 0.423829C92.6619 0.423829 92.7255 0.423829 92.7255 0.487375L98.3176 3.72824L95.2673 4.99917L106.451 64.3515C106.769 65.8766 106.515 67.5923 105.816 69.1175C105.816 69.181 105.752 69.181 105.752 69.2445C105.752 69.3081 105.689 69.3081 105.689 69.3716C105.053 70.8968 104.037 72.1677 102.829 72.8667L18.3127 121.734L19.0752 125.483L13.8009 122.433C13.8009 122.433 13.7373 122.433 13.7373 122.369C12.7206 121.797 11.8945 120.717 11.6403 119.192L0.138414 58.3781C-0.179318 56.9166 0.0748674 55.2643 0.646785 53.8028Z",
    fill: "#265A12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8878 125.42L108.358 76.0441C110.963 74.5826 112.488 70.5156 111.853 67.0841L100.541 7.15986C99.906 3.72836 97.237 2.1397 94.6952 3.60127L9.22529 53.0403C6.61989 54.5019 5.09478 58.5689 5.73024 62.0004L17.0415 121.925C17.677 125.356 20.2824 126.945 22.8878 125.42Z",
    fill: "url(#paint0_linear_191_2938)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54297 52.8496L51.9284 28.3843L65.2096 98.7937L23.2054 125.229C20.4094 126.818 17.6769 125.547 17.105 122.306L5.60309 61.5555C5.03117 58.3146 6.81047 54.4383 9.54297 52.8496Z",
    fill: "url(#paint1_linear_191_2938)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3771 3.85581L51.9917 28.3212L65.2093 98.2857L108.04 76.2351C110.836 74.6465 112.551 70.7066 111.979 67.5293L100.541 6.7154C99.9057 3.53808 97.1096 2.26715 94.3771 3.85581Z",
    fill: "url(#paint2_linear_191_2938)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.408 72.1047C110.709 73.8205 109.501 75.4091 108.04 76.2352L23.2052 125.229C21.6801 126.119 20.2185 126.119 19.0747 125.42L57.0754 55.4556L111.408 72.1047Z",
    fill: "url(#paint3_linear_191_2938)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1748 56.9806C6.87381 55.2648 8.0812 53.6762 9.54276 52.8501L94.3772 3.85581C95.9023 2.96617 97.3639 2.96617 98.5077 3.66518L60.507 73.6297L6.1748 56.9806Z",
    fill: "url(#paint4_linear_191_2938)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_191_2938",
    x1: 106.22,
    y1: 37.1541,
    x2: 4.64053,
    y2: 56.3155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_191_2938",
    x1: 1.91677,
    y1: 171.918,
    x2: 53.3661,
    y2: 74.7579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7677,
    stopColor: "#4C8238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45882D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_191_2938",
    x1: 141.079,
    y1: 91.427,
    x2: 69.2533,
    y2: 60.9106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7677,
    stopColor: "#3C7825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C8721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_191_2938",
    x1: 79.1792,
    y1: 172.64,
    x2: 27.9543,
    y2: 83.9529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#66AB4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46862E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_191_2938",
    x1: 80.7732,
    y1: -5.19175,
    x2: -14.5108,
    y2: 67.2813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37771E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C05E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6721e1445834fd3d8bf87cac913387b4.svg";
export { ForwardRef as ReactComponent };